// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Core__Result = require("@rescript/core/src/Core__Result.res.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.res.js");

function userStmtLocStorToUserStmt(userStmtLocStor) {
  return {
          id: "",
          label: userStmtLocStor.label,
          labelEditMode: false,
          typ: MM_wrk_editor.userStmtTypeFromStr(userStmtLocStor.typ),
          typEditMode: false,
          isGoal: userStmtLocStor.isGoal,
          isBkm: userStmtLocStor.isBkm,
          cont: MM_wrk_editor.strToCont(userStmtLocStor.cont, undefined, undefined),
          contEditMode: false,
          isDuplicated: false,
          jstfText: userStmtLocStor.jstfText,
          jstfEditMode: false,
          stmtErr: undefined,
          expr: undefined,
          jstf: undefined,
          proofTreeDto: undefined,
          src: undefined,
          proof: undefined,
          proofStatus: undefined,
          unifErr: undefined,
          syntaxErr: undefined
        };
}

function createInitialEditorState(preCtxData, stateLocStor) {
  var st_settingsV = preCtxData.settingsV.ver;
  var st_settings = preCtxData.settingsV.val;
  var st_typeColors = Belt_HashMapString.make(0);
  var st_srcs = preCtxData.srcs;
  var st_preCtxV = preCtxData.ctxV.ver;
  var st_preCtx = preCtxData.ctxV.val;
  var st_frms = MM_substitution.frmsEmpty();
  var st_parenCnt = MM_parenCounter.parenCntMake(0, 0, 0, 0, 0);
  var st_preCtxColors = Belt_HashMapString.make(0);
  var st_allTypes = [];
  var st_syntaxTypes = [];
  var st_parensMap = Belt_HashMapString.make(0);
  var st_typeOrderInDisj = Belt_HashMapInt.make(0);
  var st_descr = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.descr;
            })), "");
  var st_varsText = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.varsText;
            })), "");
  var st_wrkCtxColors = Belt_HashMapString.make(0);
  var st_disjText = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.disjText;
            })), "");
  var st_nextStmtId = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (stateLocStor) {
              return stateLocStor.stmts.length;
            })), 0);
  var st_stmts = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.stmts.map(function (stmtLocStor, i) {
                          var newrecord = Caml_obj.obj_dup(userStmtLocStorToUserStmt(stmtLocStor));
                          newrecord.id = String(i);
                          return newrecord;
                        });
            })), []);
  var st_checkedStmtIds = [];
  var st = {
    settingsV: st_settingsV,
    settings: st_settings,
    typeColors: st_typeColors,
    srcs: st_srcs,
    preCtxV: st_preCtxV,
    preCtx: st_preCtx,
    frms: st_frms,
    parenCnt: st_parenCnt,
    preCtxColors: st_preCtxColors,
    allTypes: st_allTypes,
    syntaxTypes: st_syntaxTypes,
    parensMap: st_parensMap,
    typeOrderInDisj: st_typeOrderInDisj,
    descr: st_descr,
    descrEditMode: false,
    varsText: st_varsText,
    varsEditMode: false,
    varsErr: undefined,
    wrkCtxColors: st_wrkCtxColors,
    disjText: st_disjText,
    disjEditMode: false,
    disjErr: undefined,
    wrkCtx: undefined,
    nextStmtId: st_nextStmtId,
    stmts: st_stmts,
    checkedStmtIds: st_checkedStmtIds,
    nextAction: undefined
  };
  return MM_wrk_editor.setPreCtxData(st, preCtxData);
}

function editorStateToEditorStateLocStor(state) {
  return {
          srcs: state.srcs.map(function (src) {
                return {
                        typ: src.typ,
                        fileName: src.fileName,
                        url: src.url,
                        readInstr: src.readInstr,
                        label: src.label,
                        resetNestingLevel: src.resetNestingLevel,
                        ast: undefined,
                        allLabels: []
                      };
              }),
          descr: state.descr,
          varsText: state.varsText,
          disjText: state.disjText,
          stmts: state.stmts.map(function (stmt) {
                return {
                        label: stmt.label,
                        typ: MM_wrk_editor.userStmtTypeToStr(stmt.typ),
                        isGoal: stmt.isGoal,
                        isBkm: stmt.isBkm,
                        cont: MM_wrk_editor.contToStr(stmt.cont),
                        jstfText: stmt.jstfText
                      };
              })
        };
}

function fixDisjFormat(st) {
  if (st.disjText.includes(" ")) {
    return st;
  } else {
    return {
            srcs: st.srcs,
            descr: st.descr,
            varsText: st.varsText,
            disjText: st.disjText.replaceAll(",", " "),
            stmts: st.stmts
          };
  }
}

function readEditorStateFromJsonStr(jsonStr) {
  return Core__Result.map(Expln_utils_jsonParse.parseJson(jsonStr, (function (__x) {
                    return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                  return {
                                          srcs: Expln_utils_jsonParse.arr(d, "srcs", (function (__x) {
                                                  return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                                return {
                                                                        typ: Expln_utils_jsonParse.str(d, "typ", undefined, undefined),
                                                                        fileName: Expln_utils_jsonParse.str(d, "fileName", undefined, undefined),
                                                                        url: Expln_utils_jsonParse.str(d, "url", undefined, undefined),
                                                                        readInstr: Expln_utils_jsonParse.str(d, "readInstr", undefined, undefined),
                                                                        label: Expln_utils_jsonParse.str(d, "label", undefined, undefined),
                                                                        resetNestingLevel: Expln_utils_jsonParse.bool(d, "resetNestingLevel", undefined, (function () {
                                                                                return true;
                                                                              })),
                                                                        ast: undefined,
                                                                        allLabels: []
                                                                      };
                                                              }), undefined, undefined);
                                                }), undefined, (function () {
                                                  return [];
                                                })),
                                          descr: Expln_utils_jsonParse.str(d, "descr", undefined, (function () {
                                                  return "";
                                                })),
                                          varsText: Expln_utils_jsonParse.str(d, "varsText", undefined, (function () {
                                                  return "";
                                                })),
                                          disjText: Expln_utils_jsonParse.str(d, "disjText", undefined, (function () {
                                                  return "";
                                                })),
                                          stmts: Expln_utils_jsonParse.arr(d, "stmts", (function (__x) {
                                                  return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                                return {
                                                                        label: Expln_utils_jsonParse.str(d, "label", undefined, undefined),
                                                                        typ: Expln_utils_jsonParse.str(d, "typ", undefined, undefined),
                                                                        isGoal: Expln_utils_jsonParse.bool(d, "isGoal", undefined, (function () {
                                                                                return false;
                                                                              })),
                                                                        isBkm: Expln_utils_jsonParse.bool(d, "isBkm", undefined, (function () {
                                                                                return false;
                                                                              })),
                                                                        cont: Expln_utils_jsonParse.str(d, "cont", undefined, undefined),
                                                                        jstfText: Expln_utils_jsonParse.str(d, "jstfText", undefined, undefined)
                                                                      };
                                                              }), undefined, undefined);
                                                }), undefined, undefined)
                                        };
                                }), undefined, undefined);
                  }), undefined, undefined), fixDisjFormat);
}

exports.userStmtLocStorToUserStmt = userStmtLocStorToUserStmt;
exports.createInitialEditorState = createInitialEditorState;
exports.editorStateToEditorStateLocStor = editorStateToEditorStateLocStor;
exports.readEditorStateFromJsonStr = readEditorStateFromJsonStr;
/* MM_wrk_editor Not a pure module */
